import { useAppSelector } from '@/Application/Hooks/Redux';
import { Typography } from '@/modules/perseo-billing/ui/react/src';
import useRegions from '@/sections/region/hooks/useRegions';

export const AppliedInvoiceBody = () => {
  const { data: cart } = useAppSelector((state) => state.cart);
  const { data: regions } = useRegions();

  const billingAddress = cart?.billingAddress;

  const region = regions?.find(
    (address) => address?.id === Number(billingAddress?.region)
  );

  const regionName = region?.name;
  const commune = region?.communes?.find(
    (commune) => commune?.code === billingAddress?.commune
  );
  const communeName = commune?.name;
  const fullAddress = `${billingAddress?.streetName} ${billingAddress?.streetNumber}, ${communeName}, ${regionName}`;

  return (
    <div className="co-flex co-flex-col co-w-full">
      <Typography>
        RUT: {billingAddress?.companyIdentityDocumentNumber}
      </Typography>
      <Typography>{billingAddress?.companyLineOfBusiness}</Typography>
      <Typography>{fullAddress}</Typography>
    </div>
  );
};
